// Nerve blocks at THI. Layout in components/hospital/texas-heart/NerveBlocks.js.
// The emphasis is initial setup: dosing, orders, pump, list. Rounding is last.

export const dosing = [
  // Seeded from the ERACS pathway; confirm before relying on it
  { block: 'Parasternal blocks (SPIP), single-shot', regimen: 'Ropivacaine 0.25%, 20–30 mL per side (dilute the 0.5% vial)', note: 'Sternotomy; placed at end of case with drapes still up', confirm: true },
  { block: 'ESP or serratus anterior catheter', regimen: 'Ropivacaine 0.2% via CADD: PIB 20 mL q2h ± PCRA 5 mL q1h PRN, or continuous 10 mL/hr + PCRA 5 mL q1h PRN', note: 'Robotic and mini-thoracotomy cases', confirm: true },
];

export const epicOrders = {
  items: [
    { name: 'Nerve Block order panel', detail: 'Coming: what it contains and when to use it' },
    { name: 'Peripheral Nerve Block Inpatient order set', detail: 'Coming: when to use it and what to select' },
  ],
};

export const pump = {
  transition: 'THI is moving to Eitan Sapphire pumps on October 15, 2026. Setup steps for the new pump will replace this placeholder.',
};

export const blockList = {
  pending: 'How to add a patient to the nerve block list: coming.',
};

export const rounding = {
  pending: 'Progress note template and what to check on rounds: coming.',
};
